module.exports = __webpack_public_path__ + "static/media/ninja-discord-icon.ce09adb2.svg";